<!--this is component to handle (no data) and (not page found) and (server error)  -->
<!-- <ng-container *ngIf="fallbackData">
  <app-no-data
    [title]="fallbackData.title"
    [message]="fallbackData.message"
    [img]="fallbackData.img"
  ></app-no-data>
</ng-container> -->

<ng-container [ngSwitch]="type">
  <app-not-found-page
    *ngSwitchCase="'pageNotFound'"
    [title]="fallbackData.title"
    [message]="fallbackData.message"
    [img]="fallbackData.img"
  ></app-not-found-page>

  <app-no-data
    *ngSwitchCase="'noData'"
    [title]="fallbackData.title"
    [message]="fallbackData.message"
    [img]="fallbackData.img"
    [isButton]="false"
  ></app-no-data>
  <app-no-data
    *ngSwitchCase="'serverError'"
    [title]="fallbackData.title"
    [message]="fallbackData.message"
    [img]="fallbackData.img"
  ></app-no-data>
  <app-no-data
    *ngSwitchCase="'noEvents'"
    [title]="fallbackData.title"
    [message]="fallbackData.message"
    [img]="fallbackData.img"
    [isButton]="false"
  ></app-no-data>

  <app-no-data
    *ngSwitchCase="'noPhotos'"
    [title]="fallbackData.title"
    [message]="fallbackData.message"
    [img]="fallbackData.img"
    [isButton]="false"
  ></app-no-data>

  <app-no-data
    *ngSwitchCase="'noVideos'"
    [title]="fallbackData.title"
    [message]="fallbackData.message"
    [img]="fallbackData.img"
    [isButton]="false"
  ></app-no-data>

  <!-- <app-server-error
    *ngSwitchCase="'serverError'"
    [title]="fallbackData.title"
    [message]="fallbackData.message"
    [img]="fallbackData.img"
  ></app-server-error> -->

  <!-- <app-generic-error *ngSwitchDefault></app-generic-error> -->
</ng-container>
